import { useCallback, useContext, useState } from "react";
import { AuthContext, AuthContextValue } from "./AuthProvider";
import { ApiError, toApiError } from "../network/mainClient/apiError";
import { TFactor } from "../models/Factors";

type SendOperationsFactorResult = {
  operationsSessionId: string;
  factor: TFactor;
};

export const useSendOperationsFactor = (): [
  SendOperationsFactorResult | null,
  boolean,
  ApiError | null,
  () => Promise<void>
] => {
  const { sendOperationsFactor } = useContext<AuthContextValue>(AuthContext);
  const [result, setResult] = useState<SendOperationsFactorResult | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<ApiError | null>(null);

  const request = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await sendOperationsFactor();
      setResult(response);
    } catch (e) {
      setError(toApiError(e));
      throw e;
    } finally {
      setIsLoading(false);
    }
  }, [sendOperationsFactor]);

  return [result, isLoading, error, request];
};
